import { isBRServer } from '@/utils/Validators/validation';

export const TAGS = {
  BILLING_BR: 'hgbr_chat_financeiro',
  BILLING_ES: 'hges_chat_financeiro',
  NOT_FOUND_BR: 'hgbr_chat_categoria_outros',
  NOT_FOUND_ES: 'hges_chat_categoria_outros',
};


export const N8N_SLUGS = {
  HOSTING: 'hosting',
  DOMAIN: 'domain',
  EMAIL: 'email',
  SITE_DOWN: 'site-down',
  SITE_BUILDERS: 'site-builders',
  BILLING: 'billing',
  PROBLEM_NOT_FOUND: 'problem-not-found',
};


export const ZENDESK_TAGS = {
  HOSTING: isBRServer ? 'hgbr_chat_compartilhado' : 'hges_chat_compartilhado',
  DOMAIN: isBRServer ? 'hgbr_chat_dominios' : 'hges_chat_dominios',
  EMAIL: isBRServer ? 'hgbr_chat_email' : 'hges_chat_email',
  SITE_DOWN: isBRServer ? 'hgbr_chat_construtor_de_sites' : 'hges_chat_constructor_de_sitios',
  SITE_BUILDERS: isBRServer ? 'hgbr_chat_construtor_de_sites' : 'hges_chat_constructor_de_sitios',
  BILLING: isBRServer ? 'hgbr_chat_financeiro' : 'hges_chat_financeiro',
  PROBLEM_NOT_FOUND: isBRServer ? 'hgbr_chat_categoria_outros' : 'hges_chat_categoria_outros',
  SELLLINGS: isBRServer ? 'vendas_br_compartilhados' : 'vendas_es_compartilhados',
};
